var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',_vm._g(_vm._b({staticClass:"sgp-toggle",attrs:{"label":_vm.titulo,"disabled":_vm.readOnly},on:{"change":_vm.mudarStatusToogle},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'v-switch',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }